<template>
    <div class="setup-content contact-info" id="step-9">
    <h3 class="color-darkblue" style="padding-top: 30px; padding-left: 20px">Review Warranty Claim</h3>
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div>
          <div v-if="status != ''" class="page-title" style="width:auto;padding-left: 20px"> Current Status: <span>{{ status }}</span></div>
          <div class="web-action-btn btn-groups" style="padding-right: 20px;">
            <template>
              <template v-if="canReviewClaim">
                <button v-if="status != 'approved' && status != 'paid'" type="button" id="approveBtn" v-on:click="approveOrRejectWarrantyClaim('approved')" class="btn btn-primary">
                  Approve</button>
                <button v-if="status != 'rejected' && status != 'paid'" type="button" id="rejectBtn" v-on:click="approveOrRejectWarrantyClaim('rejected')" class="btn btn-danger">
                  Reject</button>
              </template>
              <button v-if="reviewTab" class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoBack('step-8')">
              <i class="fp-left-arrow" style="font-size:20px;"> </i> Previous </button>
              <button v-if="!reviewTab" style="margin-right: 20px" type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                <i class="fp-back"> </i> Back
              </button>
              <button v-if="!reviewTab && filePath != null" type="button" class="btn btn-tertiary" v-on:click="downloadPdf()" >
                <i class="fp-download"> </i> Download Invoice
              </button>
              <button  type="button" class="btn btn-tertiary" v-on:click="loadWarrantyClaimPdf()" >
                <i class="fp-print"> </i> Print Claim Form
              </button>
            </template>
          </div>
        </div>
        <div class="container-fluid">
          <div id="workorder-detail work-order-view-top" class="admin-page-content work-order-view">
            <template>
              <section class="internal-container border-top-table-fl">
                <template v-if="tabData != null">
                  <div class="form-row">
                    <table class="table table-sm work-order-accordion" id="workOrder-table">
                      <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                        <tr v-if="claimTab != null" class="full-width-tr">
                          <td class="accordion-row">
                            <div class="panel panel-default">
                              <div class="panel-heading" role="tab" id="headingOne">
                                <h4 class="panel-title">
                                  <a role="button" data-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Claim Tab <i class="fp-right-arrow"></i>
                                  </a>
                                </h4>
                              </div>
                              <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                <div class="panel-body">
                                  <div>
                                    <template v-if="editSections['claim_form_section']">
                                      <claim-section-form :claimTabData="claimTab" :claimId="claimId" :hideEditSection="hideEditSection"></claim-section-form>
                                    </template>
                                    <template v-else>
                                      <div v-if="canReviewClaim" class="section-status">
                                        <status-buttons
                                          :statuses="statuses.claim_form_section_status"
                                          :status="status"
                                          :rejectionMessage="statuses.claim_form_section_rejection_message"
                                          :flag="'claim_form_section'"
                                          :updateTabularStatus="updateTabularStatus"
                                          :editSection="editSection"
                                          :showEditButton="true"
                                        >
                                        </status-buttons>
                                      </div>
                                      <div class="row list-view">
                                        <div class="col-md-6 form-group border-right">
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Servicing Location :</label>
                                            <span class="col label"> {{ claimTab.dealer_id_text }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Claim Reference # :</label>
                                            <span class="col label"> {{ claimTab.claim_number }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Claim Type :</label>
                                            <span class="col label"> {{ claimTab.claim_type_text }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Based on :</label>
                                            <span class="col label"> {{ claimTab.based_on }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Vin # :</label>
                                            <span class="col label"> {{ claimTab.product_sn.text }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Service bulletin :</label>
                                            <span class="col label"> {{ claimTab.service_bulletin }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Warranty Agreement Customer Repair:</label>
                                            <span class="col label"> {{ claimTab.wty_agreement_customer_repair }} </span>
                                          </div>
                                        </div>
                                        <div class="col-md-6 form-group border-right">
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col">Odometer or Hour meter Reading:</label>
                                            <span class="col label"> {{ claimTab.repair_distance }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Repair Order#/ Job Card #: </label>
                                            <span class="col label"> {{ claimTab.repair_order }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> PWA Auth # :</label>
                                            <span class="col label"> {{ claimTab.authorization_number }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Claim Date :</label>
                                            <span class="col label"> {{ claimTab.claim_date }} </span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col"> Created By:</label>
                                            <span class="col label"> {{claimTab.created_by_user }}</span>
                                          </div>
                                          <div class="form-row row-cols-md-2 row-cols-1">
                                            <label class="col">VEV Support Ticket:</label>
                                            <span class="col label"> {{ claimTab.wsc_ticket_no }} </span>
                                          </div>
                                        </div>
                                      </div>
                                      <h4> All Comments </h4>
                                      <template v-if="claimTab.commentArr != ''">
                                        <!--Print Backend Error message-->
                                        <ul class="comment-box">
                                          <li v-for="(responses,key) in claimTab.commentArr">
                                            <img class="avatar" src="/static/images/default.jpg " alt="">
                                            <div class="comment-details">
                                              <div class="comment-dec"><span class="user">{{responses.createdUser}}</span>({{responses.comment_type_name}}) <span>{{responses.created_at}}</span> </div>
                                              <p>{{responses.comment}}</p>
                                            </div>
                                          </li>
                                        </ul>
                                      </template>
                                      <template v-else>
                                        <p class="no-data"> No comment available </p>
                                      </template>
                                    </template>
                                    <hr class="light-hr" />
                                    <div v-if="canReviewClaim" class="section-status">
                                      <status-buttons
                                        :statuses="statuses.claim_vehicle_details_status"
                                        :status="status"
                                        :rejectionMessage="statuses.claim_vehicle_details_rejection_message"
                                        :flag="'claim_vehicle_details'"
                                        :updateTabularStatus="updateTabularStatus"
                                        :editSection="editSection"
                                        :showEditButton="false"
                                      >
                                      </status-buttons>

                                    </div>
                                    <div class="form-row">
                                      <div class="vehicle-details-table">
                                        <h5 class="color-blue font-bold">Vehicle Details</h5>
                                        <div class="table-responsive-sm">
                                          <table class="table table-sm table-bordered font-1">
                                            <thead>
                                            <tr class="table-primary">
                                              <th> Vin Chasis Number </th>
                                              <th> Model Number </th>
                                              <th> Product</th>
                                              <th> Model </th>
                                              <th> Odometer or Hour Reading <br> Miles/Kms/Hours</th>
                                              <th>Warranty Start Date</th>
                                              <th>Warranty End Date</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <td>{{ claimTab.product_sn.vin }}</td>
                                            <td>{{ claimTab.product_sn.unit_no }}</td>
                                            <td>{{ claimTab.product_sn.product }}</td>
                                            <td>{{ claimTab.product_sn.model }}</td>
                                            <td>{{ claimTab.product_sn.odometer_reading }}</td>
                                            <td>{{ claimTab.product_sn.warranty_start_date }}</td>
                                            <td>{{ claimTab.product_sn.warranty_end_date }}</td>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>

                                    <hr class="light-hr" />
                                    <div v-if="canReviewClaim" class="section-status">
                                      <status-buttons
                                        :statuses="statuses.claim_total_status"
                                        :status="status"
                                        :rejectionMessage="statuses.claim_total_rejection_message"
                                        :flag="'claim_total'"
                                        :updateTabularStatus="updateTabularStatus"
                                        :editSection="editSection"
                                        :showEditButton="false"
                                      >
                                      </status-buttons>
                                    </div>
                                    <div class="form-row">
                                      <div class="claim-totals-table center">
                                        <h5 class="color-blue font-bold"> <i class="fp-labor-man"></i>Claim Totals</h5>
                                        <div class="table-responsive-sm">
                                          <table class="table table-sm table-bordered font-1">
                                            <thead>
                                            <tr class="table-primary">
                                              <th></th>
                                              <th> Claim Amount </th>
                                              <th> Processed Amount</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                              <td>Parts Amount</td>
                                              <td>${{ this.amountFormat(claimTab.part_total_claim_amount) }}</td>
                                              <td>${{ this.amountFormat(claimTab.part_total_processed_amount) }}</td>
                                            </tr>
                                            <tr>
                                              <td>Handling</td>
                                              <td>${{ this.amountFormat(claimTab.part_handling_total_amount) }}</td>
                                              <td>${{ this.amountFormat(claimTab.part_handling_total_processed_amount) }}</td>
                                            </tr>
                                            <tr>
                                              <td>{{ labor_spelling }} Amount</td>
                                              <td>${{ this.amountFormat(claimTab.labor_total_amount) }}</td>
                                              <td>${{ this.amountFormat(claimTab.labor_processed_amount) }}</td>
                                            </tr>
                                            <tr>
                                              <td>Other Charges</td>
                                              <td>$ {{ this.amountFormat(0) }}</td>
                                              <td>$ {{ this.amountFormat(0) }}</td>
                                            </tr>
                                            <tr>
                                              <td>Total Paid</td>
                                              <td>${{ this.amountFormat(claimTab.total_claimed_paid_amount) }}</td>
                                              <td>${{ this.amountFormat(claimTab.total_processed_paid_amount) }}</td>
                                            </tr>
                                            <tr>
                                              <td>Net Paid</td>
                                              <td></td>
                                              <td>${{ this.amountFormat(claimTab.total_net_paid_amount) }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="failureTab != null" class="full-width-tr">
                          <td class="accordion-row">
                            <div class="panel panel-default">
                            <div class="panel-heading" role="tab" id="headingTwo">
                              <h4 class="panel-title">
                                <a class="collapsed" role="button" data-toggle="collapse" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                  Failure Tab <i class="fp-right-arrow"></i>
                                </a>
                              </h4>
                            </div>
                            <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                              <div class="panel-body">
                                <div>
                                  <template v-if="editSections['failure_form_section']">
                                    <failure-section-form
                                      :failureTabData="failureTab"
                                      :claimId="claimId"
                                      :hideEditSection="hideEditSection"
                                      :nonOemPartClaimAmountTotal = "partTabTotal.non_oem_part_total_claim_amount "
                                    >
                                    </failure-section-form>
                                  </template>
                                  <template v-else>
                                    <div v-if="canReviewClaim" class="section-status">
                                      <status-buttons
                                        :statuses="statuses.failure_form_section_status"
                                        :status="status"
                                        :rejectionMessage="statuses.failure_form_section_rejection_message"
                                        :flag="'failure_form_section'"
                                        :updateTabularStatus="updateTabularStatus"
                                        :editSection="editSection"
                                        :showEditButton="true"
                                      >
                                      </status-buttons>
                                    </div>
                                    <div class="row list-view">
                                      <div class="col-md-6 form-group border-right">
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Failure Date :</label>
                                          <span class="col label"> {{ failureTab.failure_date }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Repair Date :</label>
                                          <span class="col label"> {{ failureTab.repair_date }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Current MFG S/N :</label>
                                          <span class="col label"> {{ failureTab.current_mfg_sn }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> New MFG S/N :</label>
                                          <span class="col label"> {{ failureTab.new_mfg_sn }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Root Cause Part (RCP) :</label>
                                          <span class="col label"> {{ failureTab.failed_item_text }} </span>
                                        </div>
                                      </div>
                                      <div class="col-md-6 form-group border-right">
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Position/Component Code:</label>
                                          <span class="col label"> {{ failureTab.position_text }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col">Damage/Cause Code:</label>
                                          <span class="col label"> {{ failureTab.damage_cause.text }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Part Disposition: </label>
                                          <span class="col label"> {{ failureTab.failed_part_disposition }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Complaint/Condition :</label>
                                          <span class="col label"> {{ failureTab.complaint_condition }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Cause :</label>
                                          <span class="col label"> {{ failureTab.probable_cause }} </span>
                                        </div>
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                          <label class="col"> Work Performed/Correction:</label>
                                          <span class="col label"> {{ failureTab.correction }}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                  <hr class="light-hr" />
                                </div>
                              </div>
                            </div>
                          </div>
                          </td>
                        </tr>
                        <tr v-if="partsTab.length > 0" class="full-width-tr">
                          <td class="accordion-row">
                            <div class="panel panel-default">
                              <div class="panel-heading" role="tab" id="headingThree">
                                <h4 class="panel-title">
                                  <a class="collapsed" role="button" data-toggle="collapse" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    Parts Tab <i class="fp-right-arrow"></i>
                                  </a>
                                </h4>
                              </div>
                              <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                <div class="panel-body">
                                  <div class="part-line-items">
                                    <template v-if="editSections['part_line_items']">
                                      <part-line-items-section :lineItemData="partsTab" :claimId="claimId" :hideEditSection="hideEditSection"></part-line-items-section>
                                    </template>
                                    <template v-else>
                                      <div v-if="canReviewClaim" class="section-status">
                                        <status-buttons
                                          :statuses="statuses.part_line_items_status"
                                          :status="status"
                                          :rejectionMessage="statuses.part_line_items_rejection_message"
                                          :flag="'part_line_items'"
                                          :updateTabularStatus="updateTabularStatus"
                                          :editSection="editSection"
                                          :showEditButton="true"
                                          :canViewPartCalimedPrice="canViewPartCalimedPrice"
                                        >
                                        </status-buttons>

                                      </div>
                                      <div class="form-row">
                                        <div class="claim-totals-table center">
                                          <h5 class="color-blue font-bold"> <i class="fp-labor-man">Parts</i></h5>
                                          <div class="table-responsive-sm">
                                            <table class="table table-sm table-bordered font-1">
                                              <thead>
                                              <tr class="table-primary">
                                                <th>Part Number</th>
                                                <th>Quantity Claimed</th>
                                                <th v-if="canViewPartCalimedPrice">Part Claimed Price</th>
                                                <th>Dealer Price</th>
                                                <th>Total Part Claimed Amount</th>
                                                <th>Handling %</th>
                                                <th>Handling Amount</th>
                                                <th>Total</th>
                                                <th>Attachment</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              <tr v-for="(part, index) in partsTab" :key="index">
                                                <td>{{ part.part.text }}</td>
                                                <td>{{ part.qty_claimed }}</td>
                                                <td v-if="canViewPartCalimedPrice">{{ part.part_claimed_price }}</td>
                                                <td>{{ part.user_input_price }}</td>
                                                <td>{{ part.processed }}</td>
                                                <td>{{ part.handling }}</td>
                                                <td>{{ part.handling_amount }}</td>
                                                <td>{{ part.total }}</td>
                                                <td>
                                                  <template v-if="part.partAttachmentPath != null">
                                                    <i v-if="part.partAttachmentPath.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="part.partAttachmentPath.extension == 'doc' || part.partAttachmentPath.extension == 'docs'" class="fp-text-document"></i>
                                                    <i v-if="part.partAttachmentPath.extension == 'jpg' || part.partAttachmentPath.extension == 'png' || part.partAttachmentPath.extension == 'jpeg'"
                                                       class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)" v-on:click="openDocument(part.partAttachmentPath.url, part.partAttachmentPath.extension)"
                                                       v-bind:key="'fileName' + index" style="color: #098de1;">
                                                      Attached File.{{ part.partAttachmentPath.extension }}
                                                    </a>
                                                  </template>
                                                  <template v-else>
                                                    No Attachments
                                                  </template>
                                                </td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                    <hr class="light-hr" />
                                  </div>
                                  <div class="non-oem-parts">
                                    <template v-if="editSections['non_oem_line_items']">
                                      <non-oem-line-items-section
                                        :lineItemData = "nonOemParts"
                                        :claimId="claimId"
                                        :hideEditSection="hideEditSection"
                                        :totalClaimAmount="partTabTotal.part_total_claim_amount"
                                        :nonOemPartClaimAmountTotalProp="partTabTotal.non_oem_part_total_claim_amount"
                                      >
                                      </non-oem-line-items-section>
                                    </template>
                                    <template v-else>
                                      <div v-if="canReviewClaim" class="section-status">
                                        <status-buttons
                                          :statuses="statuses.non_oem_line_items_status"
                                          :status="status"
                                          :rejectionMessage="statuses.non_oem_line_items_rejection_message"
                                          :flag="'non_oem_line_items'"
                                          :updateTabularStatus="updateTabularStatus"
                                          :editSection="editSection"
                                          :showEditButton="true"
                                        >
                                        </status-buttons>

                                      </div>
                                      <div class="form-row">
                                        <div class="claim-totals-table center">
                                          <h5 class="color-blue font-bold"> <i class="fp-labor-man">Non OEM Parts</i></h5>
                                          <div class="table-responsive-sm">
                                            <table class="table table-bordered font-1">
                                              <thead>
                                              <tr class="table-primary">
                                                <th>Part</th>
                                                <th>Description</th>
                                                <th>Quantity</th>
                                                <th>Unit Price (USD)</th>
                                                <th>Total</th>
                                                <th>Attachment</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              <tr v-for="(nonOem, index) in nonOemParts" :key="index">
                                                <td>{{ nonOem.part.text }}</td>
                                                <td>{{ nonOem.description }}</td>
                                                <td>{{ nonOem.qty }}</td>
                                                <td>{{ nonOem.unit_price }}</td>
                                                <td>{{nonOem.invoice}}</td>
                                                <td>
                                                  <template v-if="nonOem.attachmentPath == null || nonOem.attachmentPath == ''">
                                                    No Attachment.
                                                  </template>
                                                  <template v-else>
                                                    <i v-if="nonOem.attachmentPath.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="nonOem.attachmentPath.extension == 'doc' || nonOem.attachmentPath.extension == 'docs'" class="fp-text-document"></i>
                                                    <i v-if="nonOem.attachmentPath.extension == 'jpg' || nonOem.attachmentPath.extension == 'png' || nonOem.attachmentPath.extension == 'jpeg'"
                                                       class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)" v-on:click="openDocument(nonOem.attachmentPath.url, nonOem.attachmentPath.extension)"
                                                       v-bind:key="'fileName' + index" style="color: #098de1;">
                                                      Attached File.{{ nonOem.attachmentPath.extension }}
                                                    </a>
                                                  </template>
                                                </td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                    <hr class="light-hr" />
                                  </div>
                                  <div class="part-totals">
                                    <div v-if="canReviewClaim" class="section-status">
                                      <status-buttons
                                        :statuses="statuses.part_total_status"
                                        :status="status"
                                        :rejectionMessage="statuses.part_total_rejection_message"
                                        :flag="'part_total'"
                                        :updateTabularStatus="updateTabularStatus"
                                        :editSection="editSection"
                                        :showEditButton="false"
                                      >
                                      </status-buttons>
                                    </div>
                                    <div class="form-row">
                                      <div class="claim-totals-table center">
                                        <h5 class="color-blue font-bold"> <i class="fp-labor-man">Parts Total</i></h5>
                                        <div class="table-responsive-sm">
                                          <table class="table table-bordered font-1">
                                            <thead>
                                            <tr class="table-primary">
                                              <th></th>
                                              <th>Claimed Amount</th>
                                              <th>Procesed Amount</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                              <td>Total Amount</td>
                                              <td>${{this.amountFormat(partTabTotal.part_total_claim_amount ) }}</td>
                                              <td>${{this.amountFormat(partTabTotal.part_total_processed_amount ) }}</td>
                                            </tr>
                                            <tr>
                                              <td>Total Handling</td>
                                              <td>${{this.amountFormat(partTabTotal.part_handling_total_amount ) }}</td>
                                              <td>${{this.amountFormat(partTabTotal.part_handling_total_processed_amount ) }}</td>
                                            </tr>
                                            <tr>
                                              <td>Total Non-Oem Parts Amount</td>
                                              <td>${{this.amountFormat(partTabTotal.non_oem_part_total_claim_amount ) }}</td>
                                              <td>${{this.amountFormat(partTabTotal.non_oem_part_total_processed_amount ) }}</td>
                                            </tr>
                                            <tr>
                                              <td>Net Total</td>
                                              <td>${{this.amountFormat(partTabTotal.part_net_total_amount ) }}</td>
                                              <td>${{this.amountFormat(partTabTotal.part_net_total_processed_amount ) }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                    <hr class="light-hr" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="laborTab.length > 0" class="full-width-tr">
                          <td class="accordion-row">
                            <div class="panel panel-default">
                              <div class="panel-heading" role="tab" id="headingFour">
                                <h4 class="panel-title">
                                  <a class="collapsed" role="button" data-toggle="collapse" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    {{ labor_spelling }} Tab <i class="fp-right-arrow"></i>
                                  </a>
                                </h4>
                              </div>
                              <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
                                <div class="panel-body">
                                  <div class="labor-line-items">
                                    <template v-if="editSections['labor_line_items']">
                                      <labor-line-items-section
                                        :lineItemData="laborTab"
                                        :laborTabTotal="laborTabTotal"
                                        :claimId="claimId"
                                        :hideEditSection="hideEditSection"
                                      >
                                      </labor-line-items-section>
                                    </template>
                                    <template v-else>
                                      <div v-if="canReviewClaim" class="section-status">
                                        <status-buttons
                                          :statuses="statuses.labor_line_items_status"
                                          :status="status"
                                          :rejectionMessage="statuses.labor_line_items_rejection_message"
                                          :flag="'labor_line_items'"
                                          :updateTabularStatus="updateTabularStatus"
                                          :editSection="editSection"
                                          :showEditButton="true"
                                        >
                                        </status-buttons>

                                      </div>
                                      <div class="form-row">
                                        <div class="claim-totals-table center">
                                          <h5 class="color-blue font-bold"> <i class="fp-labor-man">Labour</i></h5>
                                          <div class="table-responsive-sm">
                                            <table class="table table-sm table-bordered font-1">
                                              <thead>
                                              <tr class="table-primary">
                                                <th>SRT</th>
                                                <th>SRT Hours</th>
                                                <th>Claimed Hours</th>
                                                <th>Processed Hours</th>
                                                <th>{{ labor_spelling }} Rate</th>
                                                <th>{{ labor_spelling }} Claimed Amount</th>
                                                <th>{{ labor_spelling }} Processed Amount</th>
                                                <th>Attachment</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              <tr v-for="(labor, index) in laborTab" :key="index">
                                                <td>{{ labor.srt.text }}</td>
                                                <td>{{ labor.srt_hours }}</td>
                                                <td>{{ labor.claimed_hours }}</td>
                                                <td>{{ labor.processed_hours }}</td>
                                                <td>{{ labor.labor_rate }}</td>
                                                <td>{{ labor.labor_claimed_amount }}</td>
                                                <td>{{ labor.labor_processed_amount }}</td>
                                                <td>
                                                  <template v-if="labor.attachmentPath == null">
                                                    No Attachment
                                                  </template>
                                                  <template v-else>
                                                    <i v-if="labor.attachmentPath.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="labor.attachmentPath.extension == 'doc' || labor.attachmentPath.extension == 'docs'" class="fp-text-document"></i>
                                                    <i v-if="labor.attachmentPath.extension == 'jpg' || labor.attachmentPath.extension == 'png' || labor.attachmentPath.extension == 'jpeg'"
                                                       class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)" v-on:click="openDocument(labor.attachmentPath.url, labor.attachmentPath.extension)"
                                                       v-bind:key="'fileName' + index" style="color: #098de1;">
                                                      Attached File.{{ labor.attachmentPath.extension }}
                                                    </a>
                                                  </template>
                                                </td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                    <hr class="light-hr" />
                                  </div>
                                  <div class="labor-totals">
                                    <div v-if="canReviewClaim" class="section-status">
                                      <status-buttons
                                        :statuses="statuses.labor_total_status"
                                        :status="status"
                                        :rejectionMessage="statuses.labor_total_rejection_message"
                                        :flag="'labor_total'"
                                        :updateTabularStatus="updateTabularStatus"
                                        :editSection="editSection"
                                        :showEditButton="false"
                                      >
                                      </status-buttons>

                                    </div>
                                    <div class="form-row">
                                      <div class="claim-totals-table center">
                                        <h5 class="color-blue font-bold"> <i class="fp-labor-man">{{ labor_spelling }} Total</i></h5>
                                        <div class="table-responsive-sm">
                                          <table class="table table-bordered font-1">
                                            <thead>
                                            <tr class="table-primary">
                                              <th></th>
                                              <th>Claimed</th>
                                              <th>Procesed</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                              <td>{{ labor_spelling }} Hours</td>
                                              <td>{{ laborTabTotal.labor_claimed_hours }}</td>
                                              <td>{{ laborTabTotal.labor_processed_hours }}</td>
                                            </tr>
                                            <tr>
                                              <td>{{ labor_spelling }} Total Amount</td>
                                              <td>{{ laborTabTotal.labor_total_amount }}</td>
                                              <td>{{ laborTabTotal.labor_processed_amount }}</td>
                                            </tr>
                                            <tr>
                                              <td>{{ labor_spelling }} Net Amount</td>
                                              <td>{{ laborTabTotal.labor_net_claimed_amount }}</td>
                                              <td>{{ laborTabTotal.labor_net_processed_amount }}</td>
                                            </tr>
                                            <tr>
                                              <td>Dealer Net Amount</td>
                                              <td>0</td>
                                              <td>{{ laborTabTotal.dealer_net_processed_amount }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                    <hr class="light-hr" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr class="full-width-tr">
                          <td class="accordion-row">
                            <div class="panel panel-default">
                              <div class="panel-heading" role="tab" id="headingSix">
                                <h4 class="panel-title">
                                  <a class="collapsed" role="button" data-toggle="collapse" href="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    Attachment Tab <i class="fp-right-arrow"></i>
                                  </a>
                                </h4>
                              </div>
                              <div id="collapseSix" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSix">
                                <div class="panel-body">
                                  <div class="attachent-tab">
                                    <template v-if="editSections['attachment']">
                                      <attachment-tab-section
                                        :attachmentTabData="attachmentTab"
                                        :claimId="claimId"
                                        :hideEditSection="hideEditSection"
                                      >
                                      </attachment-tab-section>
                                    </template>
                                    <template v-else>
                                      <div v-if="canReviewClaim" class="section-status">
                                        <status-buttons
                                          :statuses="statuses.attachment_status"
                                          :status="status"
                                          :rejectionMessage="statuses.attachment_rejection_message"
                                          :flag="'attachment'"
                                          :updateTabularStatus="updateTabularStatus"
                                          :editSection="editSection"
                                          :showEditButton="true"
                                        >
                                        </status-buttons>

                                      </div>
                                      <div class="form-row">
                                        <div class="claim-totals-table center">
                                          <div class="table-responsive-sm">
                                            <div class="col form-group" v-if="dropZonePreviewFiles != null && dropZonePreviewFiles.length > 0">
                                              <div class="policy-attachment attachment-list-box">
                                                <label class="control-label" for="attachments"></label>
                                                <template v-for="(uFile, fKey) in dropZonePreviewFiles">
                                                  <div v-bind:key="'fileDiv' + fKey" class="attachment-list">
                                                    <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'"
                                                       class="fp-text-document"></i>
                                                    <i v-if="uFile.extension == 'jpg' || uFile.extension == 'png' || uFile.extension == 'jpeg'"
                                                       class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)"
                                                       v-on:click="openDocument(uFile.url, uFile.extension)"
                                                       v-bind:key="'fileName' + fKey">
                                                      {{ uFile.display_name }}
                                                    </a>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                  </div>
                                                </template>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                    <hr class="light-hr" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>


                      </div>
                    </table>
                  </div>
                </template>
                <template v-else>
                  <h2>Claim Tab data does not exist for this warranty claim! </h2>
                </template>
              </section>
            </template>
          </div>
        </div>
      </template>

      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  commonMixins
} from "../../mixins/commonMixins";
import LoadingContent from "@/components/LoadingContent.vue";
import ActivityLogListView from '@/components/ActivityLogList.vue';
import VendorInvoiceForm from '@/components/accounting/VendorInvoiceForm.vue';
import CrmCreate from "@/components/CrmCreate.vue";
import moment from 'moment';
import EvWarrantyClaimStatusButtons from "./EvWarrantyClaimStatusButtons.vue";
import EvClaimFormSection from "./EvClaimFormSection.vue";
import EvFailureFormSection from "./EvFailureFormSection.vue";
import EvPartLineItemsSection from "./EvPartLineItemsSection.vue";
import EvNonOemLineItemsSection from "./EvNonOemLineItemsSection.vue";
import EvLaborLineItemsSection from "./EvLaborLineItemsSection.vue";
import EvOtherChargesLineItemsSection from "./EvOtherChargesLineItemsSection.vue";
import EvOtherChargesTravelRowsSection from "./EvOtherChargesTravelRowsSection.vue";
import EvOtherChargesLocationSection from "./EvOtherChargesLocationSection.vue";
import EvAttachmentTabSection from "./EvAttachmentTabSection.vue";

Vue.component("status-buttons",EvWarrantyClaimStatusButtons);
Vue.component("claim-section-form",EvClaimFormSection);
Vue.component("failure-section-form",EvFailureFormSection);
Vue.component("part-line-items-section",EvPartLineItemsSection);
Vue.component("non-oem-line-items-section",EvNonOemLineItemsSection);
Vue.component("labor-line-items-section",EvLaborLineItemsSection);
Vue.component("other-charges-line-items-section",EvOtherChargesLineItemsSection);
Vue.component("other-charges-travel-rows-section",EvOtherChargesTravelRowsSection);
Vue.component("other-charges-location-section",EvOtherChargesLocationSection);
Vue.component("attachment-tab-section",EvAttachmentTabSection);


Vue.component("crm-create", CrmCreate);

Vue.component("loading-content", LoadingContent);
Vue.component("workorder-activity-log-list", ActivityLogListView);
Vue.component("vendor-invoice-form", VendorInvoiceForm);
export default {
  name: "EvWarrantyClaimReview",
  components: {
    clearCacheData: () => import('@/components/ClearCacheData'),
    appFooter: () => import('@/components/Footer'),
    workOrderCrmList: () => import('@/components/CrmList.vue')
  },
  mixins: [commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading: false,
    userRole: "",
    date:"",
    // variables for the warranty review page
    tabData: null,
    lineItemData: "",
    claimTab: null,
    failureTab: null,
    partsTab: [],
    laborTab: [],
    nonOemParts: [],
    partTabTotal: null,
    laborTabTotal: null,
    otherChargeTab: [],
    attachmentTab: null,
    dropZonePreviewFiles: [],
    docArr: [],
    validateDocs: [],
    claimId: null,
    status: "",
    statuses: null,
    reviewTab: true,
    filePath: null,
    editSections: {
      "claim_form_section": false,
      "claim_vehicle_details": false,
      "claim_total": false,
      "failure_form_section": false,
      "part_line_items": false,
      "non_oem_line_items": false,
      "part_total": false,
      "labor_line_items": false,
      "labor_total": false,
      "other_charges_line_items": false,
      "travel_rows": false,
      "repairing_location_form": false,
      "other_charges_total": false,
      "attachment": false,
    },
    canViewPartCalimedPrice: false,
    canReviewClaim: false,
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (element.name == "add_claim") {
            self.cantAccessPage = true;
          }
          if (element.name == 'ev_view_part_claimed_price') {
            self.canViewPartCalimedPrice = true;
          }
          if (element.name == 'ev_review_claim') {
            self.canReviewClaim = true;
          }
        }
      }
    },
  },
  mounted: function () {
    var self = this;

    var path = window.location.pathname;
    var segments = path.split("/");
    if(segments[1] == 'warranty-claim-review' && segments[2]){
      self.loadClaimData(segments[2]);
      self.reviewTab = false;
    }

    self.date = moment().format('MM/DD/YYYY hh:mm:ss a');
    if (self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined) {
      self.fromUrl = atob(self.$route.query.fromUrl);
    }
    self.getPermissions();

    //check user loggged in or not
    var userObj = localStorage.getItem("user_obj");

    //if user logged in than remove login button and registration button
    if (userObj != null) {
      var userJson = JSON.parse(userObj);
      if (userJson.roles.length > 0) {
        this.userRole = userJson.roles[0].name;

      }
    }
  },
  methods: {


    editWarrantyClaim() {

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      self.$router.push("/warranty-claim/edit/" + segments[2]);
    },

    backWarrantyClaimList() {
      var self = this;
      var url = "/warranty-claim/list";
      self.redirectPageUrl(url);
    },
    loadClaimData(claimId, flag = null) {
      var self = this;

      self.claimId = claimId;
      self.$parent.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/warranty-claim/fetch/" + claimId,
        type: "GET",
        headers: {
          'Accept': 'application/json',
          "Access-Control-Allow-Origin": '*',
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
          "Cache-Control": "no-cache"
        },
        data: {
          claimType: "EV_CLAIM",
        },
        crossDomain: true,
        dataType: "json",
        success: function (data) {
          self.$parent.loading = false;
          if(data.content.line_item_data !== undefined && data.content.tabData !== undefined){
            self.lineItemData = data.content.line_item_data;
            self.tabData = data.content.tabData;
            self.claimTab = self.tabData.claimTab;
            self.failureTab = self.tabData.failureTab;
            self.partsTab = self.lineItemData.part_items;
            self.partTabTotal = self.tabData.partTabTotal;
            self.nonOemParts = self.partTabTotal.non_oem_parts;
            self.laborTab = self.lineItemData.labor_items;
            self.laborTabTotal = self.tabData.laborTabTotal;
            self.otherChargeTab = self.tabData.otherChargeTab;
            self.attachmentTab = self.tabData.attachmentTab;
            self.dropZonePreviewFiles = self.attachmentTab.file_path;
            self.statuses = self.tabData.statuses;
            if(data.content.invoice_file != null){
              self.filePath = data.content.invoice_file;
            }
            if(self.dropZonePreviewFiles != null){
              self.loadFilesPreview();
            }else{
              self.dropZonePreviewFiles = [];
            }
          }
          self.status = data.content.status;
        },
        error: function (jqXHR, exception) {
          self.$parent.loading = false;
          self.Registerbtn = "Register";
          self.generateStatusCodeMessage(jqXHR, true, 'asset-group-warranties-search')
        }
      });
    },
    loadFilesPreview: function () {
      var self = this;
      self.docArr = [];
      self.validateDocs = [];
        if (self.dropZonePreviewFiles.length > 0) {
          for (const element of self.dropZonePreviewFiles) {
            if(
              element.url
              &&
              element.display_name
              &&
              element.extension
            ){
              var url = element.url;
              // get file path from url
              self.docArr.push(self.getFilePathFromUrl(element.url));
              self.validateDocs.push({
                file_name: element.display_name,
                extension: element.extension
              });
            }
          }
        }
    },
    approveOrRejectWarrantyClaim(status) {
      var self = this;
      self.loading = true;
      if (status == "approved"){
        var title = "Are you sure that you want to Approve this Warranty Claim";
      }else{
        var title = "Are you sure that you want to Reject this Warranty Claim";
      }
      self.$swal({
        title: title,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        var path = window.location.pathname;
        var segments = path.split("/");
        $.ajax({
          url: process.env.ROOT_API + "/warranty-claim/update-status",
          type: "POST",
          data: {
            claim_id: self.claimId,
            status: status
          },
          headers: {
            "Accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Authorization,X-Requested-With",
            "Cache-Control": "no-cache"
          },
          dataType: "json",
          cors: true,
          success: function (data) {
            self.loading = false;
            if (data.status == "success") {
              self.backWarrantyClaimList();
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
      });
    },
    emitDataToParent(flag = null) {
      var self = this;
      const dataToSend = {
        attachedData: self.docArr,
      };
      self.$emit("send-review-data-to-parent", dataToSend,flag);
    },
    getFilePathFromUrl(value) {

      var path = "";
      var src = value.split('/');
      var file_name = src[src.length - 1];
      var orgPath = src[src.length - 2];
      path = orgPath + "/" + file_name;
      return path;
    },
    gotoBack: function (flag) {
      var self = this;
      self.gotoBackStepMixins(flag);
    },
    updateTabularStatus(status,flag,rejectionMessage = null) {
      var self = this;
      self.loading = true;

      if (status == "approved"){
        var title = "Are you sure that you want to Approve the status for this tab ";
      }else{
        var title = "Are you sure that you want to Reject the status for this tab ";
      }
      var swalOptions = {
        title: title,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      };

      if (status === "rejected") {
        swalOptions.input = 'text';
        swalOptions.inputPlaceholder = 'Enter rejection reason';
      }
      self.$swal(swalOptions).then((result) => {
        if (result.isConfirmed || result.value) {
          var path = window.location.pathname;
          var segments = path.split("/");
          $.ajax({
            url: process.env.ROOT_API + "/update/warranty-claim-status",
            type: "POST",
            data: {
              warrantyClaimId: self.claimId,
              status: status,
              flag: flag,
              rejectionMessage: result.value || '',
            },
            headers: {
              "Accept": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Authorization": "Bearer " + localStorage.getItem("tkn"),
              "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
              "Cache-Control": "no-cache"
            },
            dataType: "json",
            cors: true,
            success: function (data) {
              self.$parent.loading = false;
              self.loading = false;
              if (data.status == "success") {
                self.statuses = data.content;
                self.status = self.statuses.warranty_claim_status;
              } else {
                console.log("Error");
              }
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.$parent.loading = false;
              console.log("ERRORRRR");
            },
          });
        }else{
          self.loading = false;
        }
      });
    },
    downloadPdf(){
      var self = this;
      if (self.filePath != null){
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href = self.filePath;
        link.download = '';
        link.target = "_blank";
        link.click();
      }
    },
    editSection(sectionName){
      this.editSections[sectionName] = true;
    },
    hideEditSection(sectionName,flag = null){
      this.editSections[sectionName] = false;
      this.loadClaimData(this.claimId);
      if (flag == "delete_attached"){
        this.editSection(sectionName);
      }
    },
    loadWarrantyClaimPdf() {
      var self = this;
      self.$parent.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/generate-warranty-claim-pdf/" + self.claimId,
        type: "GET",
        headers: {
          'Accept': 'application/json',
          "Access-Control-Allow-Origin": '*',
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
          "Cache-Control": "no-cache"
        },
        crossDomain: true,
        dataType: "json",
        success: function (data) {
          var pdfPath = data.content;
          var link = document.createElement('a');
          link.href = pdfPath;
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          self.$parent.loading = false;
        },
        error: function (jqXHR, exception) {
          self.$parent.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'asset-group-warranties-search')
        }
      });
    },
  }
};
</script>
<style scoped>
.additionClassTop {
  top: -230px !important;
}

.full-width-tr {
  width: 100%;
  display: table;
  table-layout: fixed;
}

.adjMarginRV {
  margin-right: 10px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvWarrantyClaimReview.vue